import {Injectable} from '@angular/core';
import {MatSnackBar, MatSnackBarConfig, MatSnackBarRef} from '@angular/material';
import {ApiService} from './api.service';
import {BaseService} from './base.service';
import {Product} from '../model/Entities/Product';
import {Contract} from '../model/Entities/Contract';

@Injectable()
export class BarcodeService extends BaseService {

    getProductBarcodeUrl(p: Product): string {
        if (!p || !p.id) return '';

        return this.apiRoot + `/files/products-qr/${p.id}`;
    }

    getContractBarcodeUrl(c: Contract): string {
        if (!c || !c.id) return '';

        return this.apiRoot + `/files/contracts-qr/${c.id}`;
    }

}



// WEBPACK FOOTER //
// /app/src/services/barcode.service.ts